import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { canActivate as authenticationGuard } from '../authentication/guard/authentication.guard';
import { canActivate as medicalCenterGuard } from '../medical-center/guard/medical-center.guard';
import { CountrySelectComponent } from '../standalone-components/country-select/country-select.component';
import { StepsComponent } from '../standalone-components/steps/steps.component';
import { VerificationModule } from '../verification/verification.module';
import { AppointmentCreationComponent } from './appointment-creation.component';
import { canActivate as fullAccessGuard } from './guard/full-access.guard';
import {
  canActivate as identificationStepGuard,
  IdentificationStepGuard,
} from './guard/identification-step.guard';
import {
  canActivate as patientFormGuard,
  PatientFormGuard,
} from './patient/guard/patient-form.guard';
import { AppointmentCreationService } from './service/appointment-creation.service';

const routes: Routes = [
  {
    path: 'identification',
    component: AppointmentCreationComponent,
    loadChildren: () =>
      import('./identification/identification.module').then(
        (m) => m.IdentificationModule,
      ),
    canActivate: [identificationStepGuard, fullAccessGuard, medicalCenterGuard],
  },
  {
    path: '',
    component: AppointmentCreationComponent,
    loadChildren: () =>
      import('./motive-selection/motive-selection.module').then(
        (m) => m.MotiveSelectionModule,
      ),
    canActivate: [fullAccessGuard, medicalCenterGuard],
    pathMatch: 'full',
  },
  {
    path: 'confirmation',
    component: AppointmentCreationComponent,
    loadChildren: () =>
      import('./confirmation/confirmation.module').then(
        (m) => m.ConfirmationModule,
      ),
    canActivate: [identificationStepGuard, fullAccessGuard],
  },
  {
    path: 'patient',
    loadChildren: () =>
      import('./patient/patient.module').then((m) => m.PatientModule),
    canActivate: [authenticationGuard, patientFormGuard],
  },
];

@NgModule({
  declarations: [AppointmentCreationComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    VerificationModule,
    CountrySelectComponent,
    FontAwesomeModule,
    StepsComponent,
  ],
  providers: [
    IdentificationStepGuard,
    PatientFormGuard,
    AppointmentCreationService,
  ],
})
export class AppointmentCreationModule {}
